import { render, staticRenderFns } from "./OrderUpdateItem.vue?vue&type=template&id=543feb3f&"
import script from "./OrderUpdateItem.vue?vue&type=script&lang=js&"
export * from "./OrderUpdateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports